import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getStorage, ref } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDS7H85o61KZTvUUNSLz8wf_OXi5jp_Amc",
    authDomain: "quiz-zone-9507a.firebaseapp.com",
    projectId: "quiz-zone-9507a",
    storageBucket: "quiz-zone-9507a.appspot.com",
    messagingSenderId: "864229824391",
    appId: "1:864229824391:web:033aa88a5281ff44046522"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // Initialize Firebase Authentication
const storage = getStorage(app);
const storageRef = ref(storage); // Create a reference to the root of your Firebase Storage bucket
const messaging = getMessaging(app);

// Sign in anonymously
signInAnonymously(auth)
  .catch((error) => {
    console.error('Anonymous sign-in failed', error);
  });

//Request permission for notifications
// export const requestPermission = async () => {
//     try {
//         const swRegistration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`);
//         const token = await getToken(messaging, { vapidKey: 'BH15GrJccIRYzJWkPWfCq90hjGv5crYiskeDN3vLYrVlabsdk-elZUN94Ouaqs55OYLmTJDX-uNlW_771RHTZGI', serviceWorkerRegistration: swRegistration });
//         console.log('Notification permission granted and token generated:', token); 
//     } catch (error) {
//         console.log('User denied notification permission', error);
//     }
// };

export { db, auth, storage, storageRef, messaging, getToken, onMessage }; // Export db and auth

// Fetch questions function
export const getQuestions = async () => {
  const querySnapshot = await getDocs(collection(db, 'quizzes'));
  const questions = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const parsedOptions = JSON.parse(data.options);
    questions.push({ id: doc.id, ...data, options: parsedOptions });
  });
  return questions;
};
